import { Route, Routes } from 'react-router-dom';
import './App.css';
import Contract from './Contract';
import Plan from './Plans';
import Payment from './Payment';
import { useState } from 'react';
import Stripe from './Stripe';
import {
Elements
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';


const stripePromise = loadStripe('pk_live_51O5F9gFZtgAr5eHPy7jeusMjQh38l6JqMLq0cHutTr7nfyFbqPZOsNMJaGjfdxZ77lBlz2l7HsTDq8zSqplkasAm00agQNCSx0'); // Replace with your actual public key

 


function App() {
  const [purchase,setPurchase]=useState("")
const addtocart = (cart)=>{
  setPurchase(cart)
}
const [datafrom, setDatafrom]=useState([])

const registdata =(register)=>{
  setDatafrom(register)
}
  return (
    <div className="App">
      <Routes>

        <Route path='/' element={ <Contract  registdata={registdata}/>}/>
        <Route path='/plan' element={ <Plan addtocart={addtocart}/>}/>
        <Route path='/payment/:id' element={ 
        <Elements stripe={stripePromise}><Payment datafrom={datafrom}/></Elements>
        }/>
        <Route path='/stripe' element={ <Elements stripe={stripePromise}>
        <Stripe/></Elements>}/>
      </Routes>
   
    </div>
  );
}

export default App;
